// export default () => ({
// })

export default () => ({
    locations: [],
    locationsSelectable: [],
    locationsPaginatedData: null,
    location: null,
    isLoadingLocation: false,
    isCreatingLocation: false,
    createdDataLocation: null,
    isUpdatingLocation: false,
    updatedDataLocation: null,
    isDeletingLocation: false,
    deletedDataLocation: null,
    isLoadingLocationProduct: false,
    locationsProduct: [],
})